import { render, staticRenderFns } from "./CustomerCaseNavCard.vue?vue&type=template&id=011c8dba&scoped=true"
import script from "./CustomerCaseNavCard.vue?vue&type=script&lang=js"
export * from "./CustomerCaseNavCard.vue?vue&type=script&lang=js"
import style0 from "./CustomerCaseNavCard.vue?vue&type=style&index=0&id=011c8dba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011c8dba",
  null
  
)

export default component.exports